import { JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { CurrencyCodes } from 'pricing-pages-ui-components/constants/CurrencyCodes';
import { useAnnualMonthlyPricing, useProductPromotionIds } from './usePurchaseOptions';
import { useDisplayedCurrencyCode } from './useCurrencyDetails';
const STARTER_PRODUCT_API_NAME = 'marketing-hub-starter';

// Pages where the banner should be displayed
const INCLUDED_PAGES = ['SUITE', 'MARKETING', 'SALES', 'SERVICE', 'DATA', 'CMS', 'CONTENT', 'FREE'];
export const useStarterPromo2025Banner = ({
  screen,
  tab
}) => {
  const {
    annualPrice,
    monthlyPrice,
    loading,
    error
  } = useAnnualMonthlyPricing({
    productApiName: STARTER_PRODUCT_API_NAME
  });
  const {
    promotionIds,
    loading: promotionIdsLoading
  } = useProductPromotionIds({
    productApiName: STARTER_PRODUCT_API_NAME
  });
  const displayedCurrencyCode = useDisplayedCurrencyCode();
  // Only proceed if we have a supported currency
  const supportedCurrencyCode = displayedCurrencyCode && Object.values(CurrencyCodes).includes(displayedCurrencyCode) ? displayedCurrencyCode : null;

  // Check if eligible for promotion using the properly extracted promotion IDs
  const eligibleForPromotion = promotionIds.some(promotionId => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(promotionId));
  const isValidScreenForPromo = INCLUDED_PAGES.includes(screen) && (!tab || tab !== 'ENTERPRISE');
  const shouldShowBanner = Boolean(!loading && !promotionIdsLoading && !error && eligibleForPromotion && annualPrice && monthlyPrice && displayedCurrencyCode && isValidScreenForPromo);
  return {
    shouldShowBanner,
    error,
    annualPrice,
    monthlyPrice,
    currencyCode: supportedCurrencyCode,
    loading: loading || promotionIdsLoading
  };
};